import { FC } from "react";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { settingsDrawerOpenStateAtom } from "@ryde/shared";

import { HamburgerMenuWrapperStyled } from "./mobile.parts.styled";

export const HamburgerMenu: FC = () => {
  const setSettingsSlidingMenuOpenState = useSetRecoilState(
    settingsDrawerOpenStateAtom,
  );
  return (
    <HamburgerMenuWrapperStyled>
      <SVG_MUI.HamburgerMenu4SVG
        onClick={() => setSettingsSlidingMenuOpenState(true)}
      />
    </HamburgerMenuWrapperStyled>
  );
};
